import React from "react";
import Layout from "../../layouts/Layout";
import CompanyArea from "../../components/CompanyArea/CompanyArea";
import NewService from "./news_area_services";
import Areas from "./areas";
import Process from "./process";
import WebBAnner from "./web_banner";
import { Helmet } from "react-helmet";
import Faq from "../../components/Faq/Faq";
import AreasPages from "./AreasPages";
import AboutComponent from "./AboutComponent";
import { useParams } from "react-router-dom";
import { data } from "./data";
import PageNotFound from "../PageNotFound/pagenotfound";


const WebDesign = () => {
  const { service } = useParams();
  const serviceData = data[service]
  if (!serviceData){
    return <PageNotFound />
  }
  return (
    <>
      <Helmet>
        {serviceData.seo}
      </Helmet>
      <Layout header={1} footer={1} className="" mainClassName="">
        <WebBAnner  index={0} content={serviceData.sec1} title={serviceData.title}/>
        {serviceData.about && <AboutComponent index={0} content={serviceData.about}/>}
        {/* <CounterAreaFour /> */}
        <CompanyArea content={serviceData.sec2}/>
        <AreasPages indx={0} content={serviceData.sec3} />
        <Process content={serviceData.sec4} />
        <Faq content={serviceData.sec5}/>
        {/* <NewService /> */}
      </Layout>
    </>
  );
};

export default WebDesign;
